module.exports = __webpack_public_path__ + "img/logo-qc-en.884f77d1.svg";